import { ProductTier } from '@sparemin/api-sdk';
import bem from 'utils/bem';

const WATERMARK_FREE_TIERS = [ProductTier.ENTERPRISE, ProductTier.PRO];

export const block = bem('autogram-preview-step');

export const isHeadlinerWatermarkEnabled = (tier: ProductTier): boolean =>
  !WATERMARK_FREE_TIERS.includes(tier);

export const shouldShowWatermarksPopover = (
  tier: ProductTier,
  transitionActive?: boolean,
): boolean => !transitionActive && !WATERMARK_FREE_TIERS.includes(tier);
